import styled, { css } from 'styled-components';

const btnCss = css `
  width: 128px;
  height: 44px;
  background: var(--white);
  border: 1px solid var(--primary-color);
  border-radius: var(--border-radius-base);
  color: var(--primary-color);
  // prettier-ignore
  font-size: 14Px;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
`;
const VerificationCodeInputLayout = styled.div `
  input {
    width: 236px;
    height: 44px;
  }

  .verification-code-button {
    ${btnCss}
  }

  .verification-code-button-disabled {
    ${btnCss}
    cursor: default;

    .ant-statistic-content-value,
    .ant-statistic-content-suffix {
      color: var(--primary-color);
      font-size: 18px;
    }

    .ant-statistic-content-suffix {
      margin-left: 0;
    }
  }
`;

export { VerificationCodeInputLayout };
